import React, { Component } from "react";
import {
  Layout,
  Button,
  Row,
  Select,
  Col,
  Card,
  Avatar,
  notification,
} from "antd";
import "antd/dist/antd.css";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
} from "react-google-places-autocomplete";
import { withRouter, Link } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";

import BuyerProfileContext from "./BuyerProfileContext";
import { withAppContext } from "../../store/contextStore";
import { noAuthadd } from "../../api/Apis";
import HomesCarousel from "../../common/HomesCarousel";
import buildingLogo from "../../images/buildingLogo.png";
import buyHome from "../../images/buyHome.png";
import sellHome from "../../images/sellHome.png";
import agentHome from "../../images/agentHome.png";
import offerHome from "../../images/offerHome.png";
import arrowIcon from "../../../src/images/ArrowIcon.svg";
import arroworangeIcon from "../../../src/images/ArrowOrangeIcon.svg";

const { Content } = Layout;
const { Option } = Select;

/* ─── Design tokens matching AI site ─────────────────────── */
const T = {
  navy:    "#1A2280",
  navyD:   "#12185a",
  navyM:   "#2A3390",
  green:   "#1A5C40",
  gold:    "#D4921A",
  goldL:   "#FFD98E",
  white:   "#FFFFFF",
  offWhite:"#F8F9FF",
  g100:    "#F0F2F8",
  g400:    "#888",
  g600:    "#555",
  dark:    "#1a1a2e",
  red:     "#F75B47",
};

const styles = {
  /* Hero */
  heroWrap: {
    background: `linear-gradient(135deg, ${T.navy} 0%, ${T.navyM} 55%, ${T.green} 100%)`,
    padding: "0 0 48px",
    position: "relative",
    overflow: "hidden",
  },
  heroBgCircle1: {
    position: "absolute", top: "-120px", right: "-80px",
    width: "420px", height: "420px", borderRadius: "50%",
    background: "rgba(255,255,255,0.04)", pointerEvents: "none",
  },
  heroBgCircle2: {
    position: "absolute", bottom: "-60px", left: "-60px",
    width: "300px", height: "300px", borderRadius: "50%",
    background: "rgba(212,146,26,0.08)", pointerEvents: "none",
  },
  goldBar: {
    height: "4px",
    background: `linear-gradient(90deg, ${T.gold}, ${T.goldL}, ${T.gold})`,
  },
  heroPadding: { padding: "52px 24px 0" },
  eyebrow: {
    display: "inline-block",
    background: "rgba(212,146,26,0.18)",
    border: `1px solid rgba(212,146,26,0.45)`,
    borderRadius: "50px",
    padding: "4px 16px",
    fontSize: "11px",
    fontWeight: "800",
    color: T.gold,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: "16px",
    fontFamily: "'DM Sans', sans-serif",
  },
  heroTitle: {
    fontSize: "clamp(26px, 3.6vw, 54px)",
    fontFamily: "'DM Sans', sans-serif",
    color: T.white,
    fontWeight: "900",
    lineHeight: "1.15",
    marginBottom: "14px",
    letterSpacing: "-0.02em",
  },
  heroTitleAccent: { color: T.gold },
  heroSub: {
    fontSize: "clamp(14px, 1.5vw, 18px)",
    color: "rgba(255,255,255,0.82)",
    lineHeight: "1.6",
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: "400",
    marginBottom: "28px",
    maxWidth: "640px",
  },
  /* Checklist */
  checkRow: {
    display: "flex", alignItems: "flex-start", gap: "10px",
    marginBottom: "10px",
  },
  checkIcon: {
    width: "20px", height: "20px", minWidth: "20px",
    background: "rgba(212,146,26,0.25)",
    border: `1.5px solid ${T.gold}`,
    borderRadius: "50%", display: "flex",
    alignItems: "center", justifyContent: "center",
    marginTop: "2px",
  },
  checkText: {
    fontSize: "clamp(12px, 1.1vw, 14px)",
    color: "rgba(255,255,255,0.88)",
    lineHeight: "1.55",
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: "500",
  },
  checkTextLink: { color: T.gold, fontWeight: "700", textDecoration: "underline" },
  /* Search bar */
  searchCard: {
    background: T.white,
    borderRadius: "14px",
    padding: "16px 20px",
    margin: "36px 24px 0",
    boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    alignItems: "center",
  },
  searchLabel: {
    fontSize: "11px", fontWeight: "800",
    color: T.navy, textTransform: "uppercase",
    letterSpacing: "0.08em", marginBottom: "4px",
    fontFamily: "'DM Sans', sans-serif",
  },
  searchFieldWrap: { flex: "1", minWidth: "160px" },
  searchDivider: {
    width: "1px", height: "40px",
    background: T.g100, flexShrink: 0,
  },
  searchBtn: {
    background: `linear-gradient(135deg, ${T.gold}, #B87B14)`,
    border: "none", borderRadius: "10px",
    padding: "0 28px", height: "46px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "14px", fontWeight: "800",
    color: "#2A1600", cursor: "pointer",
    display: "flex", alignItems: "center", gap: "8px",
    flexShrink: 0,
  },
  /* CTA pill */
  joinBtn: {
    background: `linear-gradient(135deg, ${T.red}, #c04030)`,
    border: "none", borderRadius: "50px",
    padding: "0 36px", height: "52px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "15px", fontWeight: "900",
    color: T.white, letterSpacing: "0.04em",
    boxShadow: "0 4px 20px rgba(247,91,71,0.4)",
    cursor: "pointer",
  },
  /* AI Banner */
  aiBanner: {
    background: `linear-gradient(135deg, ${T.navy} 0%, ${T.navyM} 60%, ${T.green} 100%)`,
    borderRadius: "16px",
    padding: "24px 24px 20px",
    margin: "0 0 24px",
    boxShadow: "0 4px 24px rgba(26,34,128,0.18)",
  },
  aiBannerLeft: { display: "flex", alignItems: "flex-start", gap: "14px", marginBottom: "16px" },
  aiBannerEyebrow: {
    color: T.gold, fontSize: "10px", fontWeight: "800",
    textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "3px",
    fontFamily: "'DM Sans', sans-serif",
  },
  aiBannerTitle: {
    color: T.white, fontSize: "17px", fontWeight: "900",
    marginBottom: "6px", fontFamily: "'DM Sans', sans-serif",
    lineHeight: "1.3",
  },
  aiBannerSub: {
    color: "rgba(255,255,255,0.75)", fontSize: "12px",
    lineHeight: "1.6", fontFamily: "'DM Sans', sans-serif",
  },
  aiBannerBtn: {
    display: "block",
    background: T.gold, color: "#2A1600",
    borderRadius: "50px", padding: "13px 24px",
    fontWeight: "900", fontSize: "15px",
    textDecoration: "none", textAlign: "center",
    border: "none", cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
    width: "100%", boxSizing: "border-box",
    boxShadow: "0 4px 16px rgba(212,146,26,0.35)",
  },
  /* Feature cards */
  featureGrid: {
    background: T.offWhite,
    padding: "48px 24px",
  },
  featureCard: {
    background: T.white,
    borderRadius: "16px",
    border: `1.5px solid ${T.g100}`,
    padding: "28px 24px",
    height: "100%",
    textAlign: "center",
    transition: "box-shadow .2s, transform .2s",
    cursor: "default",
  },
  featureIcon: {
    width: "64px", height: "64px",
    borderRadius: "16px",
    background: T.offWhite,
    display: "flex", alignItems: "center", justifyContent: "center",
    margin: "0 auto 16px",
    border: `1.5px solid ${T.g100}`,
  },
  featureTitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "16px", fontWeight: "800",
    color: T.dark, marginBottom: "8px",
  },
  featureBody: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "13px", color: T.g600,
    lineHeight: "1.65", textAlign: "center",
  },
  /* Stats strip */
  statsStrip: {
    background: T.navy,
    padding: "32px 24px",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "0",
  },
  statItem: {
    textAlign: "center",
    padding: "0 32px",
    borderRight: "1px solid rgba(255,255,255,0.12)",
    minWidth: "140px",
  },
  statNum: {
    color: T.gold, fontSize: "32px", fontWeight: "900",
    fontFamily: "'DM Sans', sans-serif", lineHeight: "1",
    marginBottom: "6px",
  },
  statLabel: {
    color: "rgba(255,255,255,0.72)", fontSize: "12px",
    fontFamily: "'DM Sans', sans-serif", fontWeight: "600",
    textTransform: "uppercase", letterSpacing: "0.06em",
  },
  /* Why section */
  whySection: { padding: "56px 24px" },
  sectionEyebrow: {
    fontSize: "11px", fontWeight: "800",
    color: T.green, textTransform: "uppercase",
    letterSpacing: "0.12em", marginBottom: "8px",
    fontFamily: "'DM Sans', sans-serif",
    display: "block",
  },
  sectionTitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "clamp(22px, 2.6vw, 36px)",
    fontWeight: "900", color: T.dark,
    lineHeight: "1.2", marginBottom: "8px",
    letterSpacing: "-0.01em",
  },
  sectionSub: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "15px", color: T.g400,
    lineHeight: "1.7", maxWidth: "560px",
  },
  pillCard: {
    background: T.offWhite,
    borderRadius: "14px",
    border: `1.5px solid ${T.g100}`,
    padding: "22px 20px",
    display: "flex", gap: "14px",
    alignItems: "flex-start",
    marginBottom: "14px",
  },
  pillIcon: {
    width: "42px", height: "42px", minWidth: "42px",
    borderRadius: "10px", background: T.navy,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "20px",
  },
  pillTitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "14px", fontWeight: "800",
    color: T.dark, marginBottom: "4px",
  },
  pillBody: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "12px", color: T.g600,
    lineHeight: "1.6",
  },
  /* New listings section */
  listingsSection: {
    background: T.offWhite,
    padding: "48px 0 40px",
  },
  listingsSectionInner: { padding: "0 24px 16px" },
  listingsTitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "clamp(20px, 2.4vw, 30px)",
    fontWeight: "900", color: T.dark,
    marginBottom: "6px",
  },
  /* Bottom CTA */
  bottomCTA: {
    background: `linear-gradient(135deg, ${T.navy}, ${T.navyM} 60%, ${T.green})`,
    padding: "56px 24px",
    textAlign: "center",
  },
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      citySearch: "",
      displayCityState: "",
      cities: {
        searchLocation: [],
        type: "",
        citiesList: [],
      },
    };
  }

  componentDidMount = () => {
    this.getIpAddress();
  };

  getIpAddress = () => {
    axios
      .get(process.env.REACT_APP_IPADDRESS)
      .then((result) => { this.addIpAddress(result.data); })
      .catch((error) => console.log("Error :", error));
  };

  addIpAddress = async (data) => {
    const payload = { entityData: data };
    try {
      const response = await noAuthadd("ipAddressAnalytics", payload);
      console.log(response);
    } catch (error) {
      console.log("Error :", error);
    }
  };

  goTo = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.props.history.push(`/register`);
  };

  handleSearches = (values) => {
    this.setState({ search: values });
  };

  handleSingleSearch = (address) => {
    let cityValue = "";
    let stateValue = "";
    let newLocations = [];
    geocodeByAddress(address.label)
      .then((results) => {
        let address = results[0].address_components;
        for (let i = 0; i < address.length; i++) {
          if (address[i].types[0] === "locality") cityValue = address[i].long_name;
          if (address[i].types[0] === "administrative_area_level_1") stateValue = address[i].short_name;
        }
        const stateCodes = JSON.parse(localStorage.getItem("stateCodesFromAdmin"));
        let setVendor = stateCodes.filter(
          (restState) =>
            restState.stateName.toLowerCase() === stateValue.toLowerCase() ||
            restState.stateType.toLowerCase() === stateValue.toLowerCase()
        );
        if (setVendor && setVendor.length > 0) {
          let newSearchLocation = { cityName: cityValue, stateName: stateValue, locationType: "location" };
          newLocations.push(newSearchLocation);
          this.setState({
            cities: {
              searchLocation: newLocations, type: "location",
              citiesList: [...this.state.cities.citiesList, `${stateValue}:${cityValue}`],
            },
          });
        } else {
          notification["error"]({
            message: "Please enter valid city...",
            description: "You can search cities from MA, CT, RI, NH states",
            placement: "topLeft",
          });
        }
      })
      .catch((error) => console.error("Error", error));
  };

  handleSearchNow = () => {
    const { search, citySearch, cities } = this.state;
    if (cities && cities.citiesList && cities.citiesList.length > 0) {
      localStorage.setItem("selectedCities", JSON.stringify(cities));
    }
    const filterCitySearch = { cities: citySearch };
    if (filterCitySearch) {
      if (search === "Off MLS Homes") {
        this.props.history.push("/offMLSHomes");
        this.props.context.setCity(citySearch, this.state.displayCityState);
      } else if (search === "Buyers") {
        this.props.history.push("/buyers");
      } else {
        this.props.context.setCity(citySearch, this.state.displayCityState);
        this.props.history.push("/homes");
      }
      if (filterCitySearch && filterCitySearch.cities !== "") {
        this.props.context.setFilterData(filterCitySearch);
      }
    }
  };

  openAITools = (e) => {
    e.preventDefault();
    const base = "https://ai.myhomebuddha.com?mode=buyer";
    const userLogin = localStorage.getItem("userLogin");
    if (userLogin) {
      const { Auth } = require("aws-amplify");
      Auth.currentSession()
        .then((session) => {
          const token = session.getIdToken().getJwtToken();
          window.open(`${base}&token=${encodeURIComponent(token)}`, "_blank");
        })
        .catch(() => window.open(base, "_blank"));
    } else {
      window.open(base, "_blank");
    }
  };

  render() {
    const checks = [
      { text: "Search on and off MLS homes for sale — find listings you won't see anywhere else." },
      { text: "Know who the listing agent is. Choose who you want to talk to, and when." },
      {
        text: "AI Tools for Buyers, Sellers, Agents & Homeowners — research, analyze, and manage smarter.",
        link: { href: "https://ai.myhomebuddha.com", label: "Try OUR AI Tools →" },
      },
      { text: "Sell on your terms: list for free, no pressure, no MLS hassle." },
      { text: "Manage homeownership with the My Home Buddha Homeowner Portal — For a healthier, wealthier & wiser home." },
      { text: "Find your perfect lending & agent team — local experts matched to your needs." },
    ];

    const features = [
      {
        img: buyHome, alt: "Buy a Home",
        title: "Buy a Home",
        body: "Browse MLS and Off MLS listings. Choose to connect with the seller, listing agent, or a local buyer's agent who works for you. Full transparency, your way.",
      },
      {
        img: sellHome, alt: "Sell a Property",
        title: "Sell a Property",
        body: "List for free, off-market or on. Set your terms and timeline. Search for matching buyer profiles — cash buyers, investors, and more — without the MLS pressure.",
      },
      {
        img: agentHome, alt: "Agent Services",
        title: "Agent Services",
        body: "Create coming-soon listings, private sales, and buyer profiles. Branded AI reports. Get matched with motivated buyers and sellers before they hit the open market.",
      },
      {
        img: offerHome, alt: "Business Services",
        title: "Business Services",
        body: "Join as a vendor and connect your business directly to buyers, sellers, and agents. One platform, one audience, exponential reach.",
      },
    ];

    const pillItems = [
      {
        icon: "🔍",
        title: "Fully Transparent Home Search",
        body: "You decide who you speak to — listing agent, buyer's agent, or seller directly. No smoke and mirrors. No shotgun inquiries to five agents at once.",
      },
      {
        icon: "🏚️",
        title: "Off-Market Opportunities",
        body: "Agents and sellers add listings you won't find anywhere else: coming-soon, private sales, 'would sell for right fit.' Find your perfect home before it goes public.",
      },
      {
        icon: "🤖",
        title: "AI-Powered Research & Tools",
        body: "Full AI property research, verified market values, inspection analysis, home health scoring, buyer readiness checks, and agent-branded reports — all in one place.",
      },
      {
        icon: "🏡",
        title: "Homeowner Portal",
        body: "Manage your home's health, track your wealth, and stay wise. Maintenance reminders, home value tracking, and AI-powered advice — your home working for you.",
      },
    ];

    return (
      <>
        <Layout style={{ width: "100%", background: "#fff" }}>
          <Content>

            {/* ── HERO ────────────────────────────────────────── */}
            <div style={styles.heroWrap}>
              <div style={styles.heroBgCircle1} />
              <div style={styles.heroBgCircle2} />
              <div style={styles.goldBar} />

              <div style={styles.heroPadding}>
                <Row gutter={[40, 40]} align="middle">
                  <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                    <div style={styles.eyebrow}>My Home Buddha &mdash; Powered by AI</div>
                    <h1 style={styles.heroTitle}>
                      The Smarter Way to{" "}
                      <span style={styles.heroTitleAccent}>Buy, Sell &amp; Manage</span>{" "}
                      Your Home.
                    </h1>
                    <p style={styles.heroSub}>
                      Search homes, get your home value, use AI-powered tools, and manage homeownership — all in one fully transparent platform built for buyers, sellers, agents, and homeowners.
                    </p>

                    {/* Checklist */}
                    <Row gutter={[16, 0]}>
                      {checks.map((c, i) => (
                        <Col xs={24} sm={24} md={12} key={i}>
                          <div style={styles.checkRow}>
                            <div style={styles.checkIcon}>
                              <CheckCircleOutlined style={{ color: T.gold, fontSize: "11px" }} />
                            </div>
                            <span style={styles.checkText}>
                              {c.text}{" "}
                              {c.link && (
                                <a
                                  href={c.link.href}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={styles.checkTextLink}
                                  onClick={this.openAITools}
                                >
                                  {c.link.label}
                                </a>
                              )}
                            </span>
                          </div>
                        </Col>
                      ))}
                    </Row>

                    {/* CTAs — AI Tools prominent gold, Join secondary */}
                    <div style={{ marginTop: "28px", display: "flex", gap: "12px", flexWrap: "wrap" }}>
                      <a
                        href="https://ai.myhomebuddha.com"
                        target="_blank"
                        rel="noreferrer"
                        onClick={this.openAITools}
                        style={{
                          display: "inline-flex", alignItems: "center", gap: "8px",
                          background: T.gold, color: "#2A1600",
                          borderRadius: "50px", padding: "0 30px", height: "52px",
                          fontFamily: "'DM Sans', sans-serif",
                          fontSize: "15px", fontWeight: "900",
                          textDecoration: "none",
                          boxShadow: "0 4px 20px rgba(212,146,26,0.45)",
                          letterSpacing: "0.02em", flexShrink: 0,
                        }}
                      >
                        🤖 Try AI Tools Free →
                      </a>
                      <button style={styles.joinBtn} onClick={() => this.goTo()}>
                        Join For Free
                      </button>
                    </div>
                    <div style={{
                      marginTop: "10px", fontSize: "11px",
                      color: "rgba(255,255,255,0.5)",
                      fontFamily: "'DM Sans', sans-serif",
                    }}>
                      No credit card needed &bull; Free to search &bull; AI tools included
                    </div>
                  </Col>

                  {/* Right side — visual accent (desktop only) */}
                  <Col xs={0} sm={0} md={0} lg={10} xl={10}>
                    <div style={{
                      display: "flex", flexDirection: "column", gap: "10px",
                      padding: "8px 0 0 8px",
                    }}>
                      {[
                        { icon: "🏠", label: "AI Property Research", sub: "Verified values · Comps · Health score" },
                        { icon: "📋", label: "Home Inspection Analysis", sub: "Upload any report · AI flags risks" },
                        { icon: "🎯", label: "Buyer Readiness Score", sub: "DTI · Credit · Buying power estimate" },
                        { icon: "📍", label: "Prospecting Map", sub: "Save & track properties in real time" },
                      ].map((item, i) => (
                        <div key={i} style={{
                          background: "rgba(255,255,255,0.09)",
                          border: "1.5px solid rgba(255,255,255,0.15)",
                          borderRadius: "12px", padding: "14px 16px",
                          display: "flex", gap: "12px", alignItems: "center",
                          backdropFilter: "blur(4px)",
                        }}>
                          <span style={{ fontSize: "24px", flexShrink: 0 }}>{item.icon}</span>
                          <div>
                            <div style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontSize: "13px", fontWeight: "800", color: T.white,
                            }}>{item.label}</div>
                            <div style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontSize: "11px", color: "rgba(255,255,255,0.65)", marginTop: "2px",
                            }}>{item.sub}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>

                {/* ── SEARCH BAR ──────────────────────────── */}
                <div style={styles.searchCard}>
                  <div style={styles.searchFieldWrap}>
                    <div style={styles.searchLabel}>I'm looking for</div>
                    <Select
                      onChange={this.handleSearches}
                      placeholder="Select…"
                      bordered={false}
                      style={{ width: "100%", fontFamily: "'DM Sans', sans-serif" }}
                    >
                      <Option value="Buyers">Buyers</Option>
                      <Option value="Homes">Homes</Option>
                      <Option value="Off MLS Homes">Off MLS Homes</Option>
                    </Select>
                  </div>
                  <div style={styles.searchDivider} />
                  <div style={{ ...styles.searchFieldWrap, flex: 2 }}>
                    <div style={styles.searchLabel}>City</div>
                    <div style={{ fontSize: "14px" }}>
                      <GooglePlacesAutocomplete
                        apiKey={process.env.REACT_APP_MAPS_KEY}
                        autocompletionRequest={{
                          types: ["(cities)"],
                          componentRestrictions: { country: ["us"] },
                        }}
                        selectProps={{
                          placeholder: "Enter city name…",
                          onChange: (result) => { this.handleSingleSearch(result); },
                          styles: {
                            control: (base) => ({
                              ...base, border: "none", boxShadow: "none",
                              fontFamily: "'DM Sans', sans-serif",
                            }),
                          },
                        }}
                      />
                    </div>
                  </div>
                  <button style={styles.searchBtn} onClick={this.handleSearchNow}>
                    Search Now
                    <img src={arrowIcon} alt="" style={{ width: "16px" }} />
                  </button>
                </div>
              </div>
            </div>
            {/* ── END HERO ─────────────────────────────────── */}

            {/* ── STATS STRIP ─────────────────────────────── */}
            <div style={styles.statsStrip}>
              {[
                { num: "On + Off MLS", label: "Home Listings" },
                { num: "AI-Powered", label: "Research Tools" },
                { num: "100%", label: "Transparent Platform" },
                { num: "Free", label: "To Join & Search" },
              ].map((s, i, arr) => (
                <div
                  key={i}
                  style={{
                    ...styles.statItem,
                    borderRight: i < arr.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
                  }}
                >
                  <div style={styles.statNum}>{s.num}</div>
                  <div style={styles.statLabel}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* ── AI BANNER ───────────────────────────────── */}
            <div style={{ padding: "40px 24px 0" }}>
              <div style={styles.aiBanner}>
                {/* Top row: icon + text */}
                <div style={styles.aiBannerLeft}>
                  <span style={{ fontSize: "34px", flexShrink: 0, marginTop: "2px" }}>🤖</span>
                  <div style={{ flex: 1 }}>
                    <div style={styles.aiBannerEyebrow}>My Home Buddha AI Tools</div>
                    <div style={styles.aiBannerTitle}>
                      AI-Powered Research for Buyers, Sellers, Agents &amp; Homeowners
                    </div>
                  </div>
                </div>
                {/* Features row */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "16px" }}>
                  {["🏠 Property Research","📋 Inspection Analysis","🎯 Buyer Readiness","💰 Market Values","🏡 Home Health","📑 Agent Reports"].map((item, i) => (
                    <span key={i} style={{
                      background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.2)",
                      borderRadius: "50px", padding: "4px 12px",
                      fontSize: "11px", fontWeight: "600",
                      color: "rgba(255,255,255,0.88)",
                      fontFamily: "'DM Sans', sans-serif",
                    }}>{item}</span>
                  ))}
                </div>
                {/* Full-width CTA button */}
                <a
                  href="https://ai.myhomebuddha.com?mode=buyer"
                  target="_blank"
                  rel="noreferrer"
                  onClick={this.openAITools}
                  style={styles.aiBannerBtn}
                >
                  🤖 Open AI Tools — Free →
                </a>
              </div>
            </div>

            {/* ── FEATURE CARDS ───────────────────────────── */}
            <div style={styles.featureGrid}>
              <div style={{ textAlign: "center", marginBottom: "36px" }}>
                <span style={styles.sectionEyebrow}>What We Offer</span>
                <h2 style={{ ...styles.sectionTitle, margin: "0 auto" }}>
                  Everything You Need, In One Place
                </h2>
              </div>
              <Row gutter={[20, 20]} justify="center">
                {features.map((f, i) => (
                  <Col key={i} xs={24} sm={12} md={12} lg={6} xl={6}>
                    <div style={styles.featureCard}
                      onMouseEnter={e => {
                        e.currentTarget.style.boxShadow = "0 8px 32px rgba(26,34,128,0.12)";
                        e.currentTarget.style.transform = "translateY(-3px)";
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.transform = "none";
                      }}
                    >
                      <div style={styles.featureIcon}>
                        <img src={f.img} alt={f.alt} style={{ width: "40px", height: "40px", objectFit: "contain" }} />
                      </div>
                      <div style={styles.featureTitle}>{f.title}</div>
                      <p style={styles.featureBody}>{f.body}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>

            {/* ── NEW LISTINGS ────────────────────────────── */}
            <div style={styles.listingsSection}>
              <div style={styles.listingsSectionInner}>
                <Row gutter={[24, 16]} align="bottom" style={{ marginBottom: "24px" }}>
                  <Col xs={24} md={14}>
                    <span style={styles.sectionEyebrow}>Fresh on the Market</span>
                    <h2 style={styles.listingsTitle}>New Listings For Sale</h2>
                    <p style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: "14px", color: T.g400, lineHeight: "1.65", margin: 0,
                    }}>
                      Search MLS listed and off MLS homes for sale. Create a free account to save favorites,
                      get alerts for new listings, use all AI tools, and more.{" "}
                      <a
                        href="https://ai.myhomebuddha.com"
                        target="_blank"
                        rel="noreferrer"
                        onClick={this.openAITools}
                        style={{ color: T.navy, fontWeight: "700", textDecoration: "underline" }}
                      >
                        Try our AI Tools →
                      </a>
                    </p>
                  </Col>
                  <Col xs={24} md={10} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Link onClick={() => this.goTo()}>
                      <span style={{
                        color: T.red, fontSize: "15px",
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: "700", display: "flex",
                        alignItems: "center", gap: "6px",
                      }}>
                        Learn more{" "}
                        <img src={arroworangeIcon} alt="" style={{ marginLeft: "2px" }} />
                      </span>
                    </Link>
                  </Col>
                </Row>
              </div>
              <Col span={24}>
                <HomesCarousel whereToShow="homes" limit="20" />
              </Col>
            </div>

            {/* ── WHY SECTION ─────────────────────────────── */}
            <div style={styles.whySection}>
              <Row gutter={[48, 40]} align="top">
                <Col xs={24} md={10}>
                  <span style={styles.sectionEyebrow}>Why My Home Buddha</span>
                  <h2 style={styles.sectionTitle}>A Better Real Estate Experience — For Everyone</h2>
                  <p style={styles.sectionSub}>
                    The only fully transparent, AI-driven home platform built for buyers, sellers, homeowners,
                    and agents. No games. No middlemen. Just clarity, control, and smarter decisions.
                  </p>
                  <div style={{ marginTop: "28px" }}>
                    <button style={styles.joinBtn} onClick={() => this.goTo()}>
                      Join For Free
                    </button>
                  </div>
                </Col>
                <Col xs={24} md={14}>
                  {pillItems.map((p, i) => (
                    <div key={i} style={styles.pillCard}>
                      <div style={styles.pillIcon}>{p.icon}</div>
                      <div>
                        <div style={styles.pillTitle}>{p.title}</div>
                        <p style={styles.pillBody}>{p.body}</p>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </div>

            {/* ── BUYER PROFILE CONTEXT (unchanged) ───────── */}
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <BuyerProfileContext />
            </Col>

            {/* ── BOTTOM CTA ──────────────────────────────── */}
            <div style={styles.bottomCTA}>
              <div style={{
                display: "inline-block",
                background: "rgba(212,146,26,0.18)",
                border: "1px solid rgba(212,146,26,0.4)",
                borderRadius: "50px", padding: "4px 16px",
                fontSize: "11px", fontWeight: "800",
                color: T.gold, letterSpacing: "0.1em",
                textTransform: "uppercase", marginBottom: "16px",
                fontFamily: "'DM Sans', sans-serif",
              }}>
                Ready to Get Started?
              </div>
              <h2 style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: "clamp(22px, 3vw, 40px)",
                fontWeight: "900", color: T.white,
                marginBottom: "12px", lineHeight: "1.2",
              }}>
                Join Free. Search Smarter.<br />
                <span style={{ color: T.gold }}>Live Healthier, Wealthier &amp; Wiser.</span>
              </h2>
              <p style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: "15px", color: "rgba(255,255,255,0.78)",
                maxWidth: "520px", margin: "0 auto 32px",
                lineHeight: "1.65",
              }}>
                Create your free account today and unlock MLS + off-market listings, AI-powered research tools, home health tracking, and a team of local experts ready to help.
              </p>
              <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
                <button style={styles.joinBtn} onClick={() => this.goTo()}>
                  Create Free Account
                </button>
                <a
                  href="https://ai.myhomebuddha.com"
                  target="_blank"
                  rel="noreferrer"
                  onClick={this.openAITools}
                  style={{
                    display: "inline-flex", alignItems: "center",
                    padding: "0 28px", height: "52px",
                    border: "2px solid rgba(255,255,255,0.35)",
                    borderRadius: "50px",
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "14px", fontWeight: "700",
                    color: T.white, textDecoration: "none",
                    background: "rgba(255,255,255,0.1)",
                  }}
                >
                  Explore AI Tools →
                </a>
              </div>
            </div>

          </Content>
        </Layout>
      </>
    );
  }
}

export default withAppContext(withRouter(Home));
